{
  "version": 1,
  "asset_id": "f4dfab02-b68a-46cb-9d5c-050b5cd3d6a4",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f4dfab02-b68a-46cb-9d5c-050b5cd3d6a4/ind-saas-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f4dfab02-b68a-46cb-9d5c-050b5cd3d6a4/ind-saas-1200.webp",
  "original_filename": "ind-saas-1200.webp",
  "size": 14638,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:15Z"
}
